import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/providers/data/data.service';
@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {
  activeSport: any;
  clockTaskManager: any;
  currentDate: any;
  constructor(public dataService: DataService) {
  }

  ngOnInit() {

  }
  ngAfterViewInit() {
    this.clockTaskManager = setInterval(() => {
      this.currentDate = new Date();
    }, 1000)
    
  }
}
